import {
  agentsUpdateStatusMap,
  mapUpdateStatus as mapSonarV3UpdateStatus,
} from '../flights/itineraries/sonarV3UpdateStatusMapper';

import { remapObject } from './utils';

import type {
  SkyscannerSonarV3Response,
  SkyscannerSonarCommonV1Enums,
} from '@skyscanner-internal/sonar-web-http-client';
import type { AgentBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/agentsBookingPanel';

const AGENT_SONAR_V3_REMAPPING = {
  id: { sourceKey: 'id', required: true },
  name: { sourceKey: 'name', required: true },
  is_carrier: { sourceKey: 'carrier', required: true },
  update_status: { sourceKey: 'updateStatus', required: true },
  rating: { sourceKey: 'rating' },
  feedback_count: { sourceKey: 'feedback_count' },
  partner_messages: { sourceKey: 'partnerMessages' },
} as const;

export const mapSonarV3ItemToConductorAgent = ({
  agent,
  updateStatus,
}: {
  agent?: SkyscannerSonarV3Response.Agent;
  updateStatus?: SkyscannerSonarCommonV1Enums.UpdateStatus;
}): AgentBookingPanel =>
  remapObject(AGENT_SONAR_V3_REMAPPING, {
    ...agent,
    updateStatus: mapSonarV3UpdateStatus(agentsUpdateStatusMap, updateStatus),
    feedback_count: agent?.rating?.count,
    rating: agent?.rating?.value,
  });
